export const GENERATE_REPORT = "GENERATE_REPORT"
export const GENERATE_REPORT_SUCCESS = "GENERATE_REPORT_SUCCESS"
export const GENERATE_REPORT_FAILED = "GENERATE_REPORT_FAILED"
export const GENERATE_REPORT_RESTART = "GENERATE_REPORT_RESTART"
export const GET_REPORT_DASHBOARD = "GET_REPORT_DASHBOARD"
export const GET_REPORT_DASHBOARD_SUCCESS = "GET_REPORT_DASHBOARD_SUCCESS"
export const GET_REPORT_DASHBOARD_FAILED = "GET_REPORT_DASHBOARD_FAILED"
